export default __webpack_public_path__ + "static/media/remeet-wepl-image2.910e55d1.jpg";